(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-patient-contact-types', {
                parent: 'entity',
                url: '/type-patient-contact-types',
                data: {
                    authorities: [],
                    pageTitle: 'TypePatientContactTypes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-patient-contact-types/list/type-patient-contact-types.html',
                        controller: 'TypePatientContactTypesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_PATIENT_CONTACT_TYPE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_PATIENT_CONTACT_TYPE, access);
                }]
            });
    }
})();
